exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "dev-change-employee{display:block;margin:15px;border:1px solid #c8175e;background:rgba(213,45,112,.1)}dev-change-employee .content{padding:15px;color:#333}dev-change-employee .content header h1{margin-top:0;font-family:Stag Sans;font-size:24px;font-weight:500;color:#c8175e;text-align:inherit}dev-change-employee .content header h1 span{font-weight:400;font-size:medium}dev-change-employee .content header h2{font-family:Stag Sans;font-size:18px}dev-change-employee .user{color:#666;font-size:16px}dev-change-employee input[type=text]{min-height:34px;padding:6px 8px;line-height:20px;color:#333;border:1px solid #dddfe2;border-radius:3px;width:760px;padding:7px 10px;margin-right:10px;font-size:16px;background-color:#f9f9f9}dev-change-employee a{text-decoration:none}dev-change-employee a:hover{text-decoration:underline;background-color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/features/mainRouting/index/devChangeEmployee/devChangeEmployee.scss
// module id = 1046
// module chunks = 0